import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';

import { Observable } from 'rxjs';

import { FormChangesModalsService } from './form-changes-modals.service';

@Injectable({ providedIn: 'root' })
export class UnsavedChangesGuard implements CanDeactivate<any> {
  constructor(private readonly formChangesModalsService: FormChangesModalsService) {}

  canDeactivate(): Observable<boolean> {
    return this.formChangesModalsService.confirmUnsavedChanges();
  }
}
